<div
  [ngStyle]="{ filter: loggingIn ? 'blur(5px)' : '' }"
  class="container-fluid loginMainContainer"
>
  <div class="container p-0 mt-5 loginContainer">
    <form class="row loginRow">
      <div class="col-md-6 leftSide">
        <div class="logo-side">
          <img [src]="klearAiLogoUrl" alt="Logo" />
          <div class="LoginHeading">Welcome to KlearClaims</div>
          <div class="LoginTest">
            The Most Advanced Claims Management Platform with <br />
            Native Artificial Intelligence
          </div>
        </div>
      </div>
      <div class="col-md-6 rightSide">
        <div class="row login-side">
          <div class="col-md-12">
            <img [src]="loginLogoUrl" alt="Logo" />
          </div>
          <div class="col-md-12 mt-4 mb-3">
            <h1 class="singIn">Sign In</h1>
          </div>

          <div class="col-md-9">
            <div class="form-group">
              <label class="labelCms">User Name</label>
              <input
                [(ngModel)]="userDetails.username"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                placeholder="Email"
                class="form-control"
                [disabled]="loggingIn"
              />
            </div>
          </div>

          <div class="col-md-9">
            <div class="form-group">
              <label class="labelCms">Password</label>
              <input
                [(ngModel)]="userDetails.password"
                [ngModelOptions]="{ standalone: true }"
                type="password"
                placeholder="Password"
                class="form-control"
                [disabled]="loggingIn"
              />
            </div>
          </div>

          <div class="col-md-9 text-right">
            <a (click)="forgotPassword()" class="Forgot pointer">
              Forgot Password
            </a>
          </div>

          <div class="col-md-12 mt-3">
            <button
              type="submit"
              (click)="login()"
              mat-raised-button
              color="primary"
              class="no-hover-effect btn btn-primary BtnFont14"
              [disabled]="loggingIn"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div *ngIf="loggingIn"><img class="fast-loader" src="assets/img/Kearai-loading-icon.gif" alt="Loader"></div>

